import React from 'react';
import { useNavigate } from 'react-router-dom';
import LogoIconSrc from '../../assets/icons/logo/pixle-logo.webp';
import { Home } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import './header.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

interface PublishHeaderProps {
  clearBlob?: () => void;
  /**
   * Overrides the default "Edit Video" navigation (navigate(-1)).
   * On the /recording-error page the history is [canvas, /publish, /recording-error],
   * so a single step back would land on /publish. The error page needs two
   * steps back to return to the video editor canvas page.
   */
  onEditClick?: () => void;
}

const PublishHeader: React.FC<PublishHeaderProps> = ({ clearBlob, onEditClick }) => {
  const navigate = useNavigate();
  const handleEditClick = () => {
    if (clearBlob) {
      clearBlob();
    }
    if (onEditClick) {
      onEditClick();
    } else {
      navigate(-1);
    }
  };
  return (
    <header className="header">
      <div className="main-bar">
        {/*<button className="menu-btn">
          <i className="fas fa-bars"></i>
        </button>*/}
        <IconButton
          className="home-nav-button"
          onClick={() => navigate('/')}
          aria-label="Home"
        >
          <Home />
        </IconButton>
        <img
          src={LogoIconSrc}
          className="header-logo"
          alt="Pixle"
          width="150"
          height="44"
        />

        <div className="spacer"></div>
        <button className="publish-btn" onClick={handleEditClick}>
          Edit Video <i className="fas fa-pencil-alt icon-spacing"></i>
        </button>
      </div>
    </header>
  );
};

export default PublishHeader;
